var React = require('react');

function Reorder (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_metro-redo","data-name":"Icon metro-redo","d":"M2.571,11.389a7.515,7.515,0,0,0,2.551,5.65l1.246-1.412A5.65,5.65,0,1,1,14.1,7.394L11.987,9.506h5.65V3.856L15.43,6.063a7.533,7.533,0,0,0-12.86,5.326Z","transform":"translate(-2.571 -3.856)"}));
}

Reorder.defaultProps = {"width":"15.066","height":"13.183","viewBox":"0 0 15.066 13.183"};

module.exports = Reorder;

Reorder.default = Reorder;
